import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Users from "../../pages/Users/Users";
import Accounts from "../../pages/Accounts/Accounts";
import Mentions from "../../pages/Mentions/Mentions";
import Home from "../../pages/Home/Home";
import Phones from "../../pages/Phones/Phones";
import PhoneStorage from "../../pages/Phones/PhonesStorage";
import LastMentions from "../../pages/Mentions/LastMentions";
import Costumers from "../../pages/Costumers/Costumers";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    "& .MuiAppBar-colorPrimary": {
      backgroundColor: "#01579b",
    },
  },
}));

export const MenuTab = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Home />
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Usuarios" {...a11yProps(0)} />
          <Tab label="Cuentas Sociales" {...a11yProps(1)} />
          <Tab label="Menciones" {...a11yProps(2)} />
          <Tab label="Últimas Menciones" {...a11yProps(3)} />
          <Tab label="Teléfono / Usuarios" {...a11yProps(4)} />
          <Tab label="Teléfono / Inventario" {...a11yProps(5)} />
          <Tab label="Clientes" {...a11yProps(6)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Users />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Accounts />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Mentions />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <LastMentions />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Phones />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <PhoneStorage />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <Costumers />
      </TabPanel>
    </div>
  );
};
